import type { FunctionComponent, SVGProps } from 'react';

export const Instagram: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.08789 18.5C7.08789 12.2068 12.2078 7.08691 18.5009 7.08691C24.7941 7.08691 29.914 12.2068 29.914 18.5C29.914 24.7931 24.7941 29.913 18.5009 29.913C12.2078 29.913 7.08789 24.7931 7.08789 18.5ZM8.60963 18.5C8.60963 23.9539 13.047 28.3913 18.5009 28.3913C23.9548 28.3913 28.3922 23.9539 28.3922 18.5C28.3922 13.046 23.9548 8.60865 18.5009 8.60865C13.047 8.60865 8.60963 13.046 8.60963 18.5Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5801 18.4998C11.5801 14.7046 14.6684 11.6162 18.4637 11.6162C22.2589 11.6162 25.3473 14.7046 25.3473 18.4998C25.3473 22.295 22.2589 25.3834 18.4637 25.3834C14.6684 25.3834 11.5801 22.295 11.5801 18.4998ZM13.1018 18.4998C13.1018 21.4565 15.5069 23.8616 18.4637 23.8616C21.4204 23.8616 23.8255 21.4565 23.8255 18.4998C23.8255 15.5431 21.4204 13.138 18.4637 13.138C15.5069 13.138 13.1018 15.5431 13.1018 18.4998Z"
      fill="black"
    />
    <circle cx="29.9124" cy="7.08717" r="1.52174" fill="black" />
    <rect x="1" y="1" width="35" height="35" stroke="black" />
  </svg>
);

export const Facebook: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="1" y="1" width="35" height="35" stroke="black" />
    <path
      d="M15.5007 31.8333V20.1667H10.834V15.5H15.5007V11.4167C15.5007 8.09169 18.0674 5.29169 21.334 5H26.584V9.66669H21.9173C20.9256 9.66669 20.1673 10.425 20.1673 11.4167V15.5H26.0007V20.1667H20.1674V31.8334H15.5007V31.8333Z"
      stroke="black"
    />
  </svg>
);

export const Twitter: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3998 11.5143C29.5559 11.4747 29.7511 11.5143 29.8682 11.633C29.9853 11.7518 30.0244 11.9497 29.9854 12.108C29.634 13.2558 28.9314 14.087 28.0725 14.5224V14.6411C28.0725 22.2801 22.4509 28.4941 15.5801 28.4941C11.7153 28.4941 8.59219 27.8213 7.18678 26.6734C7.03064 26.5151 6.95254 26.3172 7.03064 26.0797C7.10869 25.8818 7.30388 25.7235 7.53813 25.7235C9.84141 25.6839 11.3249 25.1298 12.457 24.4569C10.2708 24.1799 8.90444 23.1112 8.20176 21.0926C8.12366 20.8947 8.20176 20.6969 8.35791 20.5781C8.51405 20.4593 8.74829 20.4593 8.90444 20.5385C9.49002 20.9343 10.0756 21.0135 10.7783 21.0135C9.29483 20.1032 7.92847 18.5991 7.38193 16.7389C7.34289 16.541 7.42098 16.3035 7.57713 16.2243C7.77232 16.1056 7.96752 16.1452 8.12366 16.2639C8.5531 16.6201 9.02158 16.8576 9.72427 16.9764C8.20176 15.3931 7.26484 13.0579 8.59215 10.4852L8.82639 10.0102L9.21669 10.406C11.6371 12.9787 13.8623 14.1662 17.9223 14.9578V14.7994C17.9223 11.9101 20.1475 9.5353 22.9193 9.49571C24.0124 9.49571 25.5349 10.2873 26.1595 10.6435C26.1744 10.6435 26.1893 10.6493 26.2021 10.6542C26.2227 10.6622 26.2376 10.668 26.2376 10.6435C27.0184 10.4061 27.9553 10.0103 29.0484 9.5353C29.2046 9.45617 29.3998 9.49576 29.5169 9.61448C29.634 9.73325 29.673 9.89156 29.5949 10.0895C29.3998 10.6436 29.0875 11.2373 28.619 11.7914L29.3998 11.5143ZM27.2917 13.9683L27.5259 13.8891C28.2676 13.612 28.6971 13.0183 28.9704 12.5039L27.4479 13.0184C27.2527 13.0976 27.0185 13.0184 26.9404 12.8205C26.8623 12.6226 26.9013 12.3851 27.0575 12.2664C27.6821 11.7518 28.1505 11.1977 28.5019 10.604C27.7211 10.9206 27.0184 11.1977 26.4328 11.3956C26.1986 11.4747 25.9644 11.4351 25.7302 11.3164L25.7054 11.3027C25.2465 11.0487 23.8008 10.2485 22.9194 10.2873C20.5771 10.3269 18.7032 12.3455 18.7032 14.7994V15.9077L18.2347 15.8285C13.9405 15.0369 11.5591 13.8891 9.06063 11.3955C7.88947 14.4036 10.3098 16.5014 11.1297 17.0951L12.1056 17.8075H10.8954C10.1146 17.8075 9.25578 17.7284 8.475 17.3722C9.33388 19.1928 11.0906 20.5385 12.5741 20.9739L12.457 21.7655C12.1447 21.7655 11.8324 21.7655 11.5201 21.8051C10.7002 21.8447 9.95851 21.8447 9.25583 21.6072C10.0366 23.1112 11.403 23.7445 13.6282 23.7445H14.7993L13.8233 24.4569C12.6131 25.4069 11.0516 26.2776 8.35791 26.4755C9.64617 27.1088 12.0275 27.7025 15.5801 27.7025C22.0214 27.7025 27.2917 21.8447 27.2917 14.6411V13.9683Z"
      fill="black"
    />
    <rect x="1" y="1" width="35" height="35" stroke="black" />
  </svg>
);

export const Check: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.75 6L9.75 17L4.75 12"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Close: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.5 17.5l17-17M17.5 17.5l17 17M17.5 17.5L.5.5M17.5 17.5l-17 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
);

export const Hamburger: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 17.5h35M1 34.5h35M1 .5h35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const Minus: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill="currentColor" d="M0 15.8h35v2.6H0z" />
  </svg>
);

export const Plus: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4 0h-2.6v15.8H0v2.6h15.8V35h2.6V18.4H35v-2.6H18.4V0z"
      fill="currentColor"
    />
  </svg>
);

export const Search: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    strokeWidth="2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16.5" cy="16.5" r="15.5" stroke="currentColor" />
    <path d="M28 28l7.6 7.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ArrowRight: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.5 17.5l-17-17M33.5 17.5l-17 17M.5 17.5h33"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ArrowLeft: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.5 17.5l-17-17M33.5 17.5l-17 17M.5 17.5h33"
      transform="rotate(180, 17.5, 17.5)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronLeft: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="35" viewBox="0 0 21 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 17.5l17-17M2.5 17.5l17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ChevronRight: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="35" viewBox="0 0 21 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 17.5l17-17M2.5 17.5l17 17"
      transform="rotate(180, 10.5, 17.5)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronDown: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="35" viewBox="0 0 21 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 17.5l17-17M2.5 17.5l17 17"
      transform="rotate(270, 10.5, 17.5)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronUp: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="35" viewBox="0 0 21 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 17.5l17-17M2.5 17.5l17 17"
      transform="rotate(90, 10.5, 17.5)"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export const Bag: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    strokeWidth="2"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.5 6.5h34v28H.5v-28z" stroke="currentColor" />
    <path
      d="M10.5 11.5V8c0-4.1 3.4-7.5 7.5-7.5v0c4.1 0 7.5 3.4 7.5 7.5v3.5"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <rect x="24" y="11" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="9" y="11" width="3" height="3" rx="1.5" fill="currentColor" />
  </svg>
);

export const Info: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="7.5" cy="7.5" r="7" stroke="currentColor" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.72 5.17c-.1.1-.22.15-.36.15A.47.47 0 017 5.17a.51.51 0 01-.14-.37.5.5 0 01.14-.37c.1-.1.21-.14.36-.14a.49.49 0 01.5.51.5.5 0 01-.14.37zm.1 1.84v3.22H6.9V7.01h.92z"
      clipRule="evenodd"
    />
  </svg>
);

export const Logo: FunctionComponent<SVGProps<SVGSVGElement>> = ({ ...rest }) => (
  <svg width="132" height="19" viewBox="0 0 132 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M82.3447 3.38062C80.8964 1.72111 78.8275 0.891357 76.1378 0.891357H70.3447V18.1087H76.4482C78.8275 18.1087 80.6896 17.279 82.2413 15.7232C83.6896 14.1674 84.5171 12.093 84.5171 9.60377C84.4137 7.01079 83.6896 4.93641 82.3447 3.38062ZM79.3447 13.0265C78.6206 14.0637 77.5861 14.686 76.3447 14.686H74.3792V4.31409H76.2413C77.4827 4.31409 78.5171 4.83269 79.2413 5.86988C79.9654 6.80335 80.2758 8.04798 80.2758 9.39633C80.3792 10.8484 79.9654 12.093 79.3447 13.0265ZM105.207 0.891357H102.103V10.9521L96.4137 0.891357H92.0689V18.1087H95.2758V6.59591L101.793 18.1087H105.207V0.891357V0.891357ZM132 0.891357H125.793L122.69 11.2633L119.793 0.891357H113.793V18.1087H117.103V4.41781L121.138 18.1087H123.827L128.069 4.31409V18.1087H132V0.891357Z"
      fill="currentColor"
    />
    <path
      d="M49.2412 7.11451L53.3791 0.891357H49.4481L44.1722 8.87774V0.891357H40.2412V18.1087H44.1722V14.0637L46.5516 10.8484L49.7585 18.1087H54.3102L49.2412 7.11451Z"
      fill="currentColor"
    />
    <path d="M25.6551 0.891357H21.6206V18.1087H32.4827V14.686H25.6551V0.891357Z" fill="currentColor" />
    <path
      d="M9.31034 14.3749C8.89655 14.7897 8.37931 14.8935 7.65517 14.8935H4.03448V10.7447H7.86207C8.58621 10.7447 9.10345 10.9521 9.41379 11.367C9.72414 11.7819 9.93103 12.1968 9.93103 12.7153C9.82759 13.4414 9.72414 14.0637 9.31034 14.3749ZM4.03448 4.00293H7.34483C8.17241 4.00293 8.68966 4.21037 9.10345 4.52153C9.41379 4.83269 9.62069 5.24756 9.62069 5.86988C9.62069 6.38848 9.41379 6.90707 9.10345 7.21823C8.68966 7.52939 8.17241 7.73683 7.44828 7.73683H4.03448V4.00293ZM10.6552 9.1889C11.5862 8.87774 12.3103 8.46286 12.8276 7.94426C13.3448 7.32195 13.6552 6.4922 13.6552 5.55872C13.6552 4.31409 13.2414 3.2769 12.3103 2.34343C11.3793 1.30623 10.4483 0.891357 9.31034 0.891357H0V18.1087H8.58621C10.1379 18.1087 11.3793 17.6939 12.4138 16.8641C13.4483 15.9306 13.9655 14.7897 13.9655 13.4414C13.9655 12.4042 13.6552 11.4707 13.0345 10.7447C12.5172 10.0186 11.7931 9.50005 10.6552 9.1889Z"
      fill="currentColor"
    />
  </svg>
);
